/**
 * request,
    method,
    level,
    status,
    message,
 */
class Logger {
  static info(infos = {}) {
    console.log(JSON.stringify({
      ...infos,
      'level': 'INFO',
      'status': 'success',
      '@timestamp': new Date().toISOString(),
    }));
  }

  static error(errors = {}) {
    console.log(JSON.stringify({
      ...errors,
      'level': 'ERROR',
      'status': 'fail',
      '@timestamp': new Date().toISOString(),
    }));
  }
}

export default Logger;
